export type MessageVisibilityInput = {
  direction?: string | null
  status?: string | null
  deleted?: boolean
  user?: string | null
  body?: string | null
}

const HIDDEN_PLUMBING_USERS = new Set(['topic_router', 'opportunistic_runner'])
const viteEnv = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env ?? {}

export function authoredInboundUsersFromConfig(value: string | undefined): Set<string> {
  return new Set(
    (value ?? '')
      .split(',')
      .map((item) => item.trim().toLowerCase())
      .filter(Boolean),
  )
}

const AUTHORED_INBOUND_USERS = authoredInboundUsersFromConfig(
  viteEnv.VITE_AGENTCHAT_AUTHORED_INBOUND_USERS,
)

export function messageVisibleInConversation(message: MessageVisibilityInput): boolean {
  if (message.deleted) return false
  if (message.user && HIDDEN_PLUMBING_USERS.has(message.user)) return false
  if (message.direction === 'system' && message.user === 'system') {
    const body = message.body ?? ''
    if (body.includes('Imported from Telegram on') && body.includes('Original Telegram thread:')) {
      return false
    }
  }
  return true
}

export function isQueuedMessageRemoval(payload: Record<string, unknown>): boolean {
  return payload.status === 'cancelled' && payload.deleted === true
}

export function messageIsAuthoredInbound(
  message: MessageVisibilityInput,
  authoredUsers = AUTHORED_INBOUND_USERS,
): boolean {
  if (message.direction !== 'inbound') return false
  if (!(message.body ?? '').trim()) return false
  const user = (message.user ?? '').trim().toLowerCase()
  return authoredUsers.has(user)
}

export function messageIsMarkAuthoredInbound(message: MessageVisibilityInput): boolean {
  return messageIsAuthoredInbound(message)
}
